import { useEffect } from "react";
import { setupInterceptor } from "./base/utils/http";
import { store } from "./store";
import { useGlobalLoader } from "./globalRefreshLoader";

const InterceptorProvider = ({children}) => {
    const { setGlobalLoader } = useGlobalLoader();

    useEffect(() => {
        setupInterceptor(store, setGlobalLoader)
    },[setGlobalLoader])

    return children
}

export default InterceptorProvider;
